import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import './styles.scss';
import Pagination from '../../../components/pagination';
import Table from '../../../components/table';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { ACTIONS, readWorkspace, getDelivery, getDeliveryWorkspaceId, convertDeliveryWorkspace, copyDelivery, getURLTopic, getFilesWorkSpace, getFilesIdWorkSpace } from './../../../actions/delivery';
import { getNotification } from './../../../actions/notification';
import Loading from '../../../components/loading';
import lodash from 'lodash';

class Delivery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listDelivery : [],
            listDeliveryWorkspace: [],
            titleDeliveryWorkspace: '',
            memo: '',
            created_at: '',
            updated_at: '',
            totalPage: 1,
            pageSize: 20,
            currentPage: 1,
            selectedId: '',
            selectedIndex: null,
            listFiles: [],
        };

        this.onColumnClick = this.onColumnClick.bind(this);
    }

    componentDidMount() {
        this.setState({showLoading: true});
        this.props.getDelivery();
    }

    getFirstUnreadIndex(list) {
        let index = lodash.findIndex(list, (x) => x.is_unread === 1);
        if (index < 0) index = 0;

        return index;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const param = queryString.parse(this.props.location.search)
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_DATA_DELIVERY_SUCCESS) {
                const value = nextProps.response.data;
                let selectedIndex = this.getFirstUnreadIndex(value);
                let selectedWS = value[selectedIndex] || null;

                this.setState({
                    listDelivery : value,
                    showLoading: false,
                    totalPage: Math.ceil(nextProps.response.meta.total / this.state.pageSize),
                    currentPage: nextProps.response.meta.current_page,
                    selectedId: selectedWS ? selectedWS.id : null,
                    titleDeliveryWorkspace: selectedWS ? selectedWS.title : null,
                    memo: selectedWS ? selectedWS.memo : null,
                    selectedIndex: selectedIndex,
                    created_at: selectedWS ? selectedWS.memo : null,
                    updated_at: selectedWS ? selectedWS.memo : null
                }, () => {
                    this.state.selectedId && this.props.getDeliveryWorkspaceId(this.state.selectedId);
                    this.state.selectedId && this.props.getFilesWorkSpace(this.state.selectedId);
                })
            }

            if (nextProps.status === ACTIONS.GET_DATA_DELIVERY_WORKSPACE_SUCCESS) {
                this.setState({
                    listDeliveryWorkspace: nextProps.response.data ? convertDeliveryWorkspace(nextProps.response.data) : null,
                    showLoading: false
                })
            }

            if (nextProps.status === ACTIONS.COPY_DELIVERY_SUCCESS) {
                this.props.getDeliveryWorkspaceId(this.state.selectedId);
                this.setState({

                });
                toast.success('MyTopicsにコピーしました');
            }

            if (nextProps.status === ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS) {
                const value = nextProps.response;
                this.setState({
                    listFiles: value,
                })
            }
            if (nextProps.status === ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS) {
                const value = nextProps.response;
                this.setState({
                    file: value,
                })

                const blob = new Blob([value]);
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.download = this.state.selectedFileName;
                a.href = url;
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }            
        }
    }

    actionOther(value) {
        const param = queryString.parse(this.props.location.search)

        const data = {
            topic_id: value.id,
            workspace_id: +param.wsp_id
        }
        this.setState({
            showLoading: true
        })

        this.props.copyDelivery(data);
    }

    showDeliverySelect = async (value, index) => {
        try {
            await this.props.readWorkspace(value.id);
            // this.props.getDelivery(this.state.currentPage);
            let updatedList = [...this.state.listDelivery];
            updatedList[index].is_unread = 0;
            this.props.getDeliveryWorkspaceId(value.id);
            this.props.getNotification();
            this.props.getFilesWorkSpace(value.id);
            this.setState({
                titleDeliveryWorkspace: value.title,
                memo: value.memo,
                created_at: value.created_at,
                updated_at: value.updated_at,
                showLoading: true,
                listDelivery: updatedList
            });
        } catch (error) {
            console.log(error);
        }
    }

    downloadFileWorkspaceId = (idWorkSpace, id, fileName) => {
        this.setState({ 
            selectedFileId: id ,
            selectedFileName: fileName ,
        }, () => {
            this.props.getFilesIdWorkSpace(idWorkSpace, id);
        });
    }

    onColumnClick(index, data) {
        if(index !== 0) return;
        this.props.history.push(getURLTopic(data.rawItem));
    }

    onChangePage = (page) => {
        this.setState({currentPage: page});
        this.props.getDelivery(page);
    }

    render() {
        const { listDelivery } = this.state;
        return (
            <Fragment>
                <div className="wrapper-content delivery-wrapper w-100  justify-content-start">
                    <div className="delivery w-42">
                        <div className="title w-100 d-inline-flex align-items-center font-weight-bold">
                            <h3>納品</h3>
                        </div>
                        <div className="delivery-table w-100 ">
                            <div className="table-wrapper">
                                <table className="w-100 pt-1">
                                    <tbody>
                                        {
                                            listDelivery
                                                ?
                                                listDelivery.map((value, index) => {
                                                    return (
                                                        <tr key={index} onClick={() => this.showDeliverySelect(value, index)}>
                                                            <td className="w-100  flex-column justify-content-between align-items-center   none-border ">
                                                                <div className="h-100 w-100  justify-content-between ">
                                                                    <div className="d-inline-flex justify-content-start align-items-center">
                                                                        <div className="mr-1 info">
                                                                            <div className=" ">
                                                                                <h4 className="">{value.title}</h4>
                                                                                {value.topics_count > 0 && <div className="dsa-badge">{ value.topics_count }</div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="date h-100 ">
                                                                        <div className="d-inline-flex justify-content-end align-items-center">
                                                                            <div className="mr-1">更新日時：</div>
                                                                            <div>{value.updated_at}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    value.is_unread
                                                                        ? <div className="note-dot mr-1" />
                                                                        : null
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : null
                                        }
                                    </tbody>
                                </table>
                                <Pagination
                                    pageSize={this.state.pageSize}
                                    totalPages={this.state.totalPage}
                                    initialPage={this.state.currentPage}
                                    showPagination={true}
                                    onChangePage={(e) => this.getItemsPage(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="wrap-work-space">
                        <div className="work-space w-58">
                            <div className="title  flex-row align-items-center justify-content-between ">
                                <div className="content align-middle">{ this.state.titleDeliveryWorkspace }</div>
                                <div className="date  flex-column align-items-flex-end justify-content-end">
                                    <div className="delivery-date  flex-row justify-content-end align-items-center">
                                        <div className="mr-1">納品日時：</div>
                                        <div>{ this.state.created_at }</div>
                                    </div>
                                    <div className="last-update-date  flex-row justify-content-end align-items-center">
                                        <div className="mr-1">最終更新日時：</div>
                                        <div>{ this.state.updated_at }</div>
                                    </div>
                                </div>
                            </div>
                            <div className="note-space w-100 p-2">{ this.state.memo }</div>
                            <div className="wrapper-table table">
                                <div>
                                    <Table
                                        showPagination={false}
                                        showAction={true}
                                        showSearch={false}
                                        alignLeft={true}
                                        showcheckAll={false}
                                        showCheckbox={false}
                                        itemOfPage={this.state.listDeliveryWorkspace}
                                        header={this.props.header2}
                                        onColumnClick={this.onColumnClick}
                                        actionOther={(e) => this.actionOther(e)}
                                        />
                                </div>
                            </div>
                        </div>
                        <div className="work-space-action-csv">
                            <div className=" justify-content-between">
                                {this.state.listFiles ?
                                    this.state.listFiles.map((item, index) => {
                                        return (
                                            <div>
                                                <a key={index.toString()} onClick={() => this.downloadFileWorkspaceId(this.state.selectedId, item.id, item.file_name)}>
                                                    <span>{item.file_name}</span>
                                                </a>
                                            </div>
                                        )
                                    }) : null}
                            </div>
                        </div>
                    </div>
                </div>

                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ delivery }) => {
	return {
		data: delivery.data,
		header2: delivery.header2,
        table: delivery.table,
        response : delivery.response,
        status : delivery.status
	}
};

const mapDispatchToProps = dispatch => {
	return {
        getDelivery: (page) => {
            dispatch(getDelivery(page));
        },
        readWorkspace: (workSpaceId) => dispatch(readWorkspace(workSpaceId)),
        getNotification: () => dispatch(getNotification()),
        getDeliveryWorkspaceId: (id) => {
            dispatch(getDeliveryWorkspaceId(id))
        },
        copyDelivery: (data) => {
            dispatch(copyDelivery(data))
        },
        getFilesWorkSpace: (id) => {
            dispatch(getFilesWorkSpace(id))
        },
        getFilesIdWorkSpace: (idWorkSpace, id) => {
            dispatch(getFilesIdWorkSpace(idWorkSpace, id))
        }
	}
};

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Delivery);
